import { render, staticRenderFns } from "./BatteryLifeCalculator.vue?vue&type=template&id=6a791fd6"
import script from "./BatteryLifeCalculator.vue?vue&type=script&lang=js"
export * from "./BatteryLifeCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports